import { SearchFilters } from '../../search/schemas'
import { ensureArray } from '~/utility/array'

interface QueryPart {
  type?: string[]
  facet?: string[]
}

export function toQuery({
  facets,
  categoryIds,
}: SearchFilters): QueryPart | {} {
  const type = categoryIds ? categoryIds.map((catId) => `${catId}`) : []
  return {
    type,
    facet: facets,
  }
}

export function fromQuery(
  { type, facet }: Partial<QueryPart>,
  _routeBasedCategoryIds?: string[],
): {
  categoryIds?: string[]
  facets?: string[]
} {
  const categoryIds = type ? sanitizeCategoryIds(type) : []
  const facets = facet ? sanitizeFacets(facet) : []

  // Skip validation entirely - we should not remove categories from URLs
  // The only place categories should be removed is when explicitly clicking
  // the X on a facet lozenge in the UI
  // This fixes issues where /search/?type=4 was being stripped of its type

  return {
    ...(categoryIds.length > 0 ? { categoryIds } : {}),
    ...(facets.length > 0 ? { facets } : {}),
  }
}

function sanitizeCategoryIds(type: string | string[]) {
  return ensureArray(type).map((catId) => catId)
}

function sanitizeFacets(facets: string | string[]) {
  return ensureArray(facets)
}
